// ----------------------------------------------------------------------

function path(root: string, sublink: string) {
  return `${root}${sublink}`;
}

const ROOTS_DASHBOARD = "/dashboard";

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  login: "/login",
  registration: "/registration",
  forgotPassword: "/forgot-password",
  otpVerify: "/otp-verify",
  ChangePassword: "/change-password",
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  dashboard: path(ROOTS_DASHBOARD, "/dashboard"),
  users: path(ROOTS_DASHBOARD, "/users"),
  currency: path(ROOTS_DASHBOARD, "/currency"),
  deposits: path(ROOTS_DASHBOARD, "/deposits"),
  withdraw: path(ROOTS_DASHBOARD, "/withdraw"),
  reward: path(ROOTS_DASHBOARD, "/reward"),
  ClaimedRewards: path(ROOTS_DASHBOARD, "/ClaimedRewards"),
  commissions: path(ROOTS_DASHBOARD, "/commissions"),
  settings: path(ROOTS_DASHBOARD, "/settings"),
};
